var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.71 3.16L16.29 16.74L15 18.03L13.58 16.61C12.84 16.86 12.43 17 12 17C8 17 4.99 13.87 4 11C4.36 9.9 4.94 8.9 5.68 8.03L1.29 3.64L2.71 2.22L2.71 3.16ZM12 4C16 4 19.01 7.13 20 10C19.36 11.65 18.35 13.07 17.06 14.19L15.42 12.55C16.2 11.85 16.81 11 17.21 10C16.51 8.35 14.86 7 12.99 7.01L11.56 5.58C11.91 5.23 12 5 12 4ZM12 6.5C13.38 6.5 14.5 7.62 14.5 9C14.5 9.4 14.41 9.78 14.25 10.12L12.88 8.75C13.22 8.59 13.6 8.5 14 8.5H14.01L12 6.5ZM3.28 5L4.73 6.45C3.08 7.55 1.78 9.2 1.08 11C1.99 13.87 5 17 9 17C9.57 17 10.16 16.86 10.71 16.61L12.15 18.05C11.36 18.4 10.68 18.5 10 18.5C6 18.5 2.99 15.37 2 12.5C2.7 10.7 4.01 9.05 5.66 7.95L3.28 5ZM8.5 10C8.5 9.4 8.9 9 9.5 9L10.5 10L8.5 10Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.136e605b22f6ceb52c7dd1cce770bc5f.svg";
export { ForwardRef as ReactComponent };